<template>
  <div>
    <Breadcrumb msg1="收费管理" msg2="发票管理" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="5"><el-input v-model="query.invoice_no" placeholder="发票号码" clearable></el-input></el-col>
        <el-col :span="5"><el-input v-model="query.title" placeholder="发票抬头" clearable></el-input></el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button type="success" icon="el-icon-plus" @click="add">开票</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border>
        <el-table-column label="ID" prop="id" width="60"></el-table-column>
        <el-table-column label="发票号码" prop="invoiceNo" width="160"></el-table-column>
        <el-table-column label="原收费单" prop="chargeId" width="100"></el-table-column>
        <el-table-column label="客户名称" prop="customerName" width="140"></el-table-column>
        <el-table-column label="抬头" prop="title"></el-table-column>
        <el-table-column label="金额" prop="amount" width="100"></el-table-column>
        <el-table-column label="开票时间" prop="invoiceTime" width="160"></el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px" :current-page="query.page" :page-sizes="[10, 20, 50]" :page-size="query.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="pageChange"></el-pagination>
    </el-card>

    <el-dialog title="开票" :visible.sync="show" width="500px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px">
        <el-form-item label="收费单ID" required><el-input v-model.number="form.charge_id"></el-input></el-form-item>
        <el-form-item label="客户名称"><el-input v-model="form.customer_name"></el-input></el-form-item>
        <el-form-item label="发票抬头" required><el-input v-model="form.title"></el-input></el-form-item>
        <el-form-item label="金额" required><el-input v-model.number="form.amount" type="number"></el-input></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="show = false">取消</el-button>
        <el-button type="primary" @click="save">确认开票</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      query: { page: 1, limit: 10, invoice_no: '', title: '' },
      list: [],
      total: 0,
      show: false,
      form: { charge_id: null, customer_name: '', title: '', amount: 0 }
    }
  },
  created () { this.getData() },
  methods: {
    getData () {
      this.$axios.get('/invoices', res => {
        this.list = res.data.records || []
        this.total = parseInt(res.data.total) || 0
      }, this.query)
    },
    search () { this.query.page = 1; this.getData() },
    sizeChange (s) { this.query.limit = s; this.getData() },
    pageChange (p) { this.query.page = p; this.getData() },
    add () {
      this.form = { charge_id: null, customer_name: '', title: '', amount: 0 }
      this.show = true
    },
    save () {
      if (!this.form.charge_id) { this.$message.warning('请填写收费单ID'); return }
      this.$axios.post('/invoices', () => { this.show = false; this.getData() }, this.form)
    }
  }
}
</script>
